export default "__VITE_ASSET__hOJXCsxV__"